import React, { Component } from 'react';
import { Divider, Form, Header, Segment } from 'semantic-ui-react';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import CourseEnrollment from '../CourseEnrollment/CourseEnrollment';

class CourseEnrollmentAdminPanel extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            academicYearOptions: [],
            semesterOptions: [],
            semester: null,
            academicYear: null,
            loading: true,
            currentEdu: localStorage.getItem('currentEducation')
        };
        this.fetchAcademicYearOptions = this.fetchAcademicYearOptions.bind(this);
        this.fetchSemesterOptions = this.fetchSemesterOptions.bind(this);
        this.fetchCourseOptions = this.fetchCourseOptions.bind(this);
        this.fetchSemesterNumOptions = this.fetchSemesterNumOptions.bind(this);
        this.fetchCourseImplementationOptions = this.fetchCourseImplementationOptions.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        const student = JSON.parse(localStorage.getItem('student'));
        if (this.state.currentEdu) {
            this.fetchCourseOptions(student.id);
        } else {
            this.fetchCourseOptions(student.studentStudyProgramId);
        }
        this.fetchAcademicYearOptions();
    }

    fetchAcademicYearOptions() {
        axios.get('/academic-years/current').then((res) => {
            this.setState(
                { academicYear: res.data.id },
                () => { this.fetchSemesterOptions(this.state.academicYear); }
            );
        });

        // semester/by-academic-year/{academicYear}
        axios.get('/academic-years/current-and-previous/')
            .then(res => {
                const academicYearOptions = res.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    academicYearOptions,
                });
            });
    }

    fetchSemesterOptions(academicYear) {
        axios.get(`semester/by-academic-year/${academicYear}/`)
            .then(res => {
                const semesterOptions = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name.name
                }));
                this.setState({
                    semesterOptions,
                    semester: semesterOptions[0].value
                });
            });
    }

    fetchCourseOptions(id) {
        axios.get(`/course/not-passed-and-not-enrolled/${id}/`)
            .then(res => {
                this.setState({
                    courseOptions: res.data.map(el => ({
                        ...el, key: el.id, value: { id: el.id, courseBasicId: el.courseBasicId }, text: el.courseBasicName + ' | ' + (el.code ? el.code : '')
                    }))
                });
            });
    }

    fetchSemesterNumOptions(id) {
        axios.get(`/study-programs/courses/semesters/${id}/`)
            .then(res => {
                this.setState({
                    semesterNumOptions: res.data.map(el => ({
                        ...el, key: el.studyProgramSemester.id, value: el.studyProgramSemester.id, text: el.studyProgramSemester.name
                    }))
                });
            });
    }

    fetchCourseImplementationOptions(courseId, semesterId) {
        let obj = {
            id: courseId,
            mainFaculty: { id: this.state.currentEdu ? parseInt(localStorage.getItem('orgUnit'), 10) : parseInt(localStorage.getItem('orgUnitId'), 10) }
        };
        axios.post(`/course/implementations/by-ou-and-semester/${semesterId}/`, { ...obj })
            .then(res => {
                this.setState({
                    courseImplementationOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.courseBasic.name ? el.courseBasic.name + (el.code ? ' | ' + el.code : '') + (el.comment ? ' | ' + el.comment : '') : (el.code ? ' | ' + el.code : '') + (el.comment ? ' | ' + el.comment : '')
                    }))
                });
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'academicYear') { this.fetchSemesterOptions(value); }

        this.setState({
            [name]: value
        });
    }


    render() {
        const { semester, academicYear } = this.state;
        const student = JSON.parse(localStorage.getItem('student'));
        return (
            <div>
                {!this.state.currentEdu && <h1>Upis na predmet</h1>}
                {!this.state.currentEdu ? <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            {student.firstName} {student.lastName} - {student.index}
                            <Header.Subheader>
                                Ime i prezime studenta, index
                            </Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>

                            <Form.Group widths="equal">

                                <Form.Field required>
                                    <label>Akademska godina</label>
                                    <Form.Dropdown
                                        placeholder="Odaberite akademsku godinu"
                                        value={academicYear}
                                        onChange={this.handleInputChange}
                                        name="academicYear"
                                        options={this.state.academicYearOptions}
                                        search
                                        fluid
                                        selection
                                        error={this.state.academicYearErr}
                                    />
                                </Form.Field>
                                <Form.Field required>
                                    <label>Semestar</label>
                                    <Form.Dropdown
                                        placeholder="Odaberite semestar"
                                        value={semester}
                                        onChange={this.handleInputChange}
                                        name="semester"
                                        options={this.state.semesterOptions.filter(e => e.name._key !== 'other')}
                                        search
                                        fluid
                                        disabled={!this.state.academicYear}
                                        selection
                                        error={this.state.semesterErr}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        <Segment secondary> <CourseEnrollment
                            update={this.state.update}
                            courseOptions={this.state.courseOptions}
                            semesterNumOptions={this.state.semesterNumOptions}
                            courseImplementationOptions={this.state.courseImplementationOptions}
                            semester={this.state.semester}
                            fetchCourseOptions={this.fetchCourseOptions}
                            fetchSemesterNumOptions={this.fetchSemesterNumOptions}
                            fetchCourseImplementationOptions={this.fetchCourseImplementationOptions}
                        />
                        </Segment>
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group> :
                    <Segment.Group>
                        <Segment>
                            <Form>
                                <Form.Group widths="equal">

                                    <Form.Field required>
                                        <label>Akademska godina</label>
                                        <Form.Dropdown
                                            placeholder="Odaberite akademsku godinu"
                                            value={academicYear}
                                            onChange={this.handleInputChange}
                                            name="academicYear"
                                            options={this.state.academicYearOptions}
                                            search
                                            fluid
                                            selection
                                            error={this.state.academicYearErr}
                                        />
                                    </Form.Field>
                                    <Form.Field required>
                                        <label>Semestar</label>
                                        <Form.Dropdown
                                            placeholder="Odaberite semestar"
                                            value={semester}
                                            onChange={this.handleInputChange}
                                            name="semester"
                                            options={this.state.semesterOptions.filter(e => e.name._key !== 'other')}
                                            search
                                            fluid
                                            disabled={!this.state.academicYear}
                                            selection
                                            error={this.state.semesterErr}
                                        />
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                        </Segment>
                        <Segment>
                            <Segment secondary> <CourseEnrollment
                                update={this.state.update}
                                courseOptions={this.state.courseOptions}
                                semesterNumOptions={this.state.semesterNumOptions}
                                courseImplementationOptions={this.state.courseImplementationOptions}
                                semester={this.state.semester}
                                fetchCourseOptions={this.fetchCourseOptions}
                                fetchSemesterNumOptions={this.fetchSemesterNumOptions}
                                fetchCourseImplementationOptions={this.fetchCourseImplementationOptions}
                            /></Segment>
                        </Segment>
                        <ToastContainer hideProgressBar />
                    </Segment.Group>}
            </div>
        );
    }
}

export default CourseEnrollmentAdminPanel;



// WEBPACK FOOTER //
// ./src/views/Admin/Students/CourseEnrollment/CourseEnrollmentAdminPanel.js